// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__S9EbY"};